import { FC, ReactElement } from 'react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import { MealItemModifiers } from '../MealItemModifiers/MealItemModifiers';
import { IResponseComboItem } from '~/types/combo';
import { IResponseProductModifier } from '~/types/products';

interface IProps {
  item: IResponseComboItem;
}

export const MealItemSelectors: FC<IProps> = (props: IProps): ReactElement => {
  const onChangeModifier = (modifier: IResponseProductModifier) => {
    orderProductModalStore.onChangeModifierInComboItem(props.item, modifier);
  };

  // TODO: combo exclusions
  // const onChangeExclusions = (id: number) => {
  //   orderProductModalStore.onChangeExclusionsInComboItem(item, id);
  // };

  return (
    <div className="d-flex flex-column mb-4 gap-15">
      {props.item.modifiers?.length ? <MealItemModifiers item={props.item} onChangeModifier={onChangeModifier} /> : null}
      {/* TODO: combo exclusions */}
      {/* {item.exclusions?.length ? <MealItemExclusions exclusions={item.exclusions} onChangeExclusions={onChangeExclusions} /> : null} */}
    </div>
  );
};
